import React from "react";

export default function About(){
    return(
        <section className="section about-section">
            <h1 className="section-title">about us</h1>
            <p>This is the about section</p>
        </section>
    )
}